import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CollectionComponent } from './collection/collection.component';
import { DetailPageComponent } from './detail-page/detail-page.component';
import { RbTagsComponent } from './rb-tags/rb-tags.component';
import { DetailComponent } from './detail/detail.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: "", redirectTo: "tags", pathMatch: "full" },
      {
        path: 'tags', component: RbTagsComponent
      },
      {
        path: 'collections/:name/:id', component: CollectionComponent
      },
      { path: 'detail/:name/:id/:data', component: DetailPageComponent },
     
      { path: 'detail/:name/:id', component: DetailComponent },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MeanderRbRoutingModule { }
